export const CREDIT_CARD_TEST_ID = 'credit-card.button';
